const dataFields = {
  cardHolderName: {
    name: "card_holder_name",
    placeholder: "Digite o nome do titular",
    header: "Nome no cartão",
    autoComplete: "cc-name",
  },
  cardNumber: {
    name: "card_number",
    placeholder: "Digite o número do cartão",
    header: "Numero do cartão",
    maxLength: 19,
    autoComplete: "cc-number",
  },
  expirationDate: {
    name: "expiration_date",
    placeholder: "(MM/AA)",
    header: "Data de vencimento",
    maxLength: 5,
    autoComplete: "cc-exp",
  },
  securityCode: {
    name: "security_code",
    type: "text",
    placeholder: "",
    header: "Código de segurança",
    maxLength: 4,
    autoComplete: "cc-csc",
  },
};

export default dataFields;
